module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("myProfileView.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("myProfileView.choosePictureAndText")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("myProfileView.myProfilePicture")))]), _vm._v(" "), _c('div', {
    staticClass: "profile-picture-chooser"
  }, [_c('input', {
    staticClass: "profile-picture",
    attrs: {
      "type": "file",
      "id": "fileinput",
      "accept": ".jpg,.jpeg,.png"
    },
    on: {
      "change": _vm.profilePictureSelected
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fileinput"
    }
  }, [(!_vm.store.currentUser.profilePicture) ? _c('div', [_vm._m(0)]) : _c('div', [_c('img', {
    attrs: {
      "src": 'data:image/jpg;base64,' + this.profilePicture,
      "width": "150"
    }
  })])]), _vm._v(" "), (_vm.invalidImageSelected) ? _c('div', [_vm._v(_vm._s(_vm.$t("myProfileView.allowedImageTypes")))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "slogan"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("myProfileView.slogan")))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.slogan),
      expression: "user.slogan"
    }],
    attrs: {
      "id": "slogan",
      "rows": "2",
      "placeholder": _vm.$t('myProfileView.slogan')
    },
    domProps: {
      "value": (_vm.user.slogan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.slogan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("myProfileView.language")))]), _vm._v(" "), _c('div', {
    staticClass: "radio-content"
  }, _vm._l((_vm.locales), function(l) {
    return _c('label', {
      key: l
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "locale",
        "id": l
      },
      domProps: {
        "value": l,
        "checked": _vm.store.currentUser.locale == l
      },
      on: {
        "click": function($event) {
          _vm.setLocale(l)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "label-text"
    }, [_vm._v(_vm._s(_vm.$t(("myProfileView.locale_" + l))))]), _vm._v(" "), _c('span', {
      staticClass: "checkmark icon-checkmark"
    })])
  })), _vm._v(" "), _c('p', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button button-green",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("myProfileView.saveChanges")))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.instructions
    }
  }, [_vm._v(_vm._s(_vm.$t("myProfileView.instructions")))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.privacySettings
    }
  }, [_vm._v(_vm._s(_vm.$t("myProfileView.privacySettings")))]), _vm._v(" "), _c('button', {
    staticClass: "button button-primary",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t("myProfileView.logout")))])]), _c('p', {
    staticClass: "saved-notification",
    class: {
      'fadeout': _vm.changesSaved
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("myProfileView.changesSaved")) + "\r\n        ")]), _vm._v(" "), _c('p')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-picture-circle"
  }, [_c('span', {
    staticClass: "icon icon-grin file-input-img"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7428e040","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/MyProfileView.vue
// module id = 124
// module chunks = 0